<template>
  <!-- header area -->
  <!-- <div class="content no-top-padding header-area"> -->
  <div class="row" style="margin-bottom: 12px;">
    <div class="col-md-12 col-lg-8">
      <div
        class="widget widget-alpha widget-alpha--color-amaranth"
        style="margin-bottom: 10px;  height: 100%;"
      >
        <div class="animated-area">
          <!-- {{ device }} -->
          <!-- <div class="title">{{ pvp }} {{pvp/1000 !=0?pvp/1000:getValue(loadEnergySource['pvSource']||0)}}</div> -->
          <div class="flex justify-between">
            <!-- top left -->
            <!-- {{device.BatteryData.TotalBatCur}}*
            {{device.BatteryData.TotalBatVolt}}={{parseFloat(device.BatteryData.TotalBatVolt)*parseFloat(device.BatteryData.TotalBatCur)}}-->
            <!-- {{getBatteryWattage()}} -->
            <!-- {{loadEnergySource}} -->
            <custom-animated-icon
              title="Solar"
              :value="
                pvp / 1000 != 0
                  ? pvp / 1000
                  : getValue(loadEnergySource['pvSource'] || 0)
              "
              data-value
              color="rgba(16, 156, 241, 0.9)"
              :line="pvp / 1000 == 0 && pvp == 0 ? null : 'top-left'"
              :image="require('@/assets/img/solar-panel.svg')"
            ></custom-animated-icon>

            <!-- top right   :data-value="getBatteryWattage()+' kW'" -->
            <custom-animated-icon
              title="Battery"
              :value="
                getValue(loadEnergySource['batterySource'] || 0) == 0
                  ? device['BatteryData'] && device['BatteryData']['SOC']
                  : getValue(loadEnergySource['batterySource'] || 0)
              "
              :line="
                getValue(loadEnergySource['batterySource'] || 0) == 0
                  ? null
                  : 'top-right'
              "
              :unit="
                getValue(loadEnergySource['batterySource'] || 0) == 0
                  ? '%'
                  : 'kW'
              "
              :data-value="getBatteryWattage() + 'kW'"
              color="rgba(250, 113, 111, 0.46)"
              :image="require('@/assets/img/battery.svg')"
            ></custom-animated-icon>
          </div>

          <div class="flex justify-center">
            <!-- center -->
            <!-- {{device['BatteryData']['CurrentState']}} -->
            <!-- {{(isSmartController)}} -->
            <!-- {{[getValue(acoap)==0?null:'top-left' ,device['BatteryData']['CurrentState'] ==chargeState?'bottom-left':null]}} -->
            <custom-animated-icon
              :title="isSmartController ? 'Smart Controller' : 'Inverter'"
              :value="getValue(acoap) == 0 ? pvp / 1000 : getValue(acoap)"
              :data-value="getBatteryWattage() + 'kW'"
              color="rgba(114, 184, 76, 0.9)"
              :isCenterItem="true"
              :lines="[
                getValue(acoap) == 0 ? null : 'top-left',
                (device['BatteryData'] && device['BatteryData']['CurrentState']) == chargeState
                  ? 'bottom-left'
                  : null
              ]"
              :image="require('@/assets/img/electric-meter.svg')"
            ></custom-animated-icon>
          </div>

          <div class="flex justify-between">
            <!-- bottom left -->
            <custom-animated-icon
              title="Grid"
              :value="getValue(loadEnergySource['gridSource'] || getGridStatus)"
              data-value
              :line="
                getValue(loadEnergySource['gridSource'] || 0) == 0
                  ? null
                  : 'bottom-left'
              "
              color="rgba(255, 185, 70, 0.9)"
              :image="require('@/assets/img/energy.svg')"
            ></custom-animated-icon>

            <!-- bottom right -->
            <custom-animated-icon
              title="Load"
              :value="getValue(acoap)"
              data-value
              color="#8f82b0"
              :image="require('@/assets/img/home-run.svg')"
            ></custom-animated-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-lg-4">
      <!-- class="widget widget-alpha widget-alpha--color-amaranth" -->
      <div
        style="margin-bottom: 0px; height: 100%; justify-content:center; display: flex;"
      >
        <div class="chart-section">
          <custom-pie-chart
            v-if="loadEnergySource"
            orient="horizontal"
            :loading="loadingChartData"
            :data="pieChart"
            @onReady="handleOnChartReady"
          ></custom-pie-chart>
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import customAnimatedIcon from "./components/customAnimatedIcon";

import Vue from "vue";

import customPieChart from "./components/customPieChart";

// import { HTTP as IOTHTTP } from "../../../store/actions";
// import moment from "moment";

export default {
  data() {
    return {
      loadingChartData: false,
      chargeState: "Charging",
      acoap: 0,
      gdv: 0,
      pvp: 0,
      pieChart: {}
    };
  },
  props: {
    device: {
      type: Object,
      default: null
    }
  },
  computed: {
    isSmartController: {
      get() {
        try {
          let { InverterData } = this.device;
          let dcop = InverterData &&  InverterData.length > 0 && InverterData[0]["DCOutputPower"];
          if (Number.isNaN(dcop) || dcop == undefined) {
            return false;
          } else return true;
        } catch (error) {
          console.log("error => ", error);
          // return false
        }
      }
    },
    getGridStatus: {
      get() {
        let modeData = this.device["ModeData"];
        modeData = modeData && modeData[0]["Mode"] ? modeData[0]["Mode"] : "";

        return this.gridCalc(modeData);
      }
    },
    loadEnergySource: {
      get() {
        let chartDataNode = {
          InverterData: this.mergeInverterPower(this.device)
        };

        return this.processLoadEnergySourceVisualization(
          chartDataNode["InverterData"],
          this.device["ModeData"],
          this.device["MiscData"]
        );
      }
    }
  },
  components: {
    "custom-animated-icon": customAnimatedIcon,
    "custom-pie-chart": customPieChart
  },
  methods: {
    getBatteryWattage() {
      let wattage =
        ((this.device.BatteryData && this.device.BatteryData.TotalBatVolt || 0) *
          (this.device.BatteryData && this.device.BatteryData.TotalBatCur || 0)) /
        1000;
      // alert(wattage);
      wattage = wattage < 0 ? wattage * -1 : wattage;
      return Math.abs(wattage).toFixed(3);
    },

    handleOnChartReady() {
      this.pieChart = {
        title: "Energy Source(kW)",
        data: this.pieChartData(this.loadEnergySource)
      };
    },
    pieChartData(displayData) {
      const result = [
        {
          value: this.computePieChartData(displayData || 9, "pvSource"),
          name: "PV",
          itemStyle: {
            color: "rgba(16, 156, 241,0.4)" // blue
          }
        },
        {
          value: this.computePieChartData(displayData, "gridSource"),
          name: "Grid",
          itemStyle: {
            color: "rgba(255, 185, 70,0.47)" // yellow
          }
        },
        {
          value: this.computePieChartData(displayData, "batterySource"),
          name: "Battery",
          itemStyle: {
            color: "rgba(250, 113, 111, 0.46)" // red
          }
        }
      ];
      return result;
    },

    computePieChartData(loadEnergySource, key) {
      if (loadEnergySource == null || loadEnergySource[key] == null) return;
      return loadEnergySource[key] / 1000;
    },
    gridCalc(mode) {
      if (mode == "L" || mode == "E" || mode == "Y") {
        return 1;
      } else {
        return 0;
      }
    },
    getValue(wattValue) {
      return `${wattValue / 1000}`;
    },
    transformChartData(InverterDataList) {
      return InverterDataList.reduce((aggr, tmpCurr) => {
        // let tmpCurr = transformMapData(c_item);
        Object.keys(tmpCurr).map(singleKey => {
          aggr[singleKey] = aggr[singleKey]
            ? Number(aggr[singleKey]) + Number(tmpCurr[singleKey])
            : Number(tmpCurr[singleKey]);
          // aggr[singleKey] =
          //   Number(aggr[singleKey]) + Number(tmpCurr[singleKey]);
        });
        return aggr;
      }, {});
    },
    mergeInverterPower(eventPayload) {
      let inverterTrans = this.transformChartData(
        eventPayload["InverterData"] ? eventPayload["InverterData"] : []
      );
      let powerTrans = this.transformChartData(
        eventPayload["PowerData"] ? eventPayload["PowerData"] : []
      );
      console.log({ inverterTrans, powerTrans });

      return {
        ...powerTrans,
        ...inverterTrans
      };
    },
    processLoadEnergySourceVisualization(data, modeData, miscData) {
      let loadEnergySource = {
        pvSource: 0,
        gridSource: 0,
        batterySource: 0
      };

      let pvp = (this.pvp =
        data && data["PVChargingPower"]
          ? parseInt(data["PVChargingPower"])
          : data && data["PVCgP1"]
          ? parseInt(data["PVCgP1"])
          : parseInt(data["PVCgP "]) || 0);
      console.log({
        data,
        modeData,
        pvp1: data.PVCgP,
        pvp
      });

      let gdv = (this.gdv =
        miscData && miscData["GridPower"]
          ? parseInt(miscData["GridPower"])
          : 0);

      let acoap = (this.acoap =
        data && data["ACOutputApparentPower"]
          ? parseInt(data["ACOutputApparentPower"])
          : data && data["ACOutputTotalApparentPower"]
          ? parseInt(data["ACOutputTotalApparentPower"])
          : data && data["DCOutputPower"]
          ? parseInt(data["DCOutputPower"])
          : 0);
      let mode = modeData && modeData[0]["Mode"] ? modeData[0]["Mode"] : "";
      if (pvp >= acoap) {
        return (loadEnergySource = {
          pvSource: acoap,
          gridSource: 0,
          batterySource: 0
        });
      }

      if (pvp < acoap) {
        if (pvp > 0 && (mode === "L" || mode === "E" || mode === "Y")) {
          return (loadEnergySource = {
            pvSource: pvp,
            gridSource: gdv,
            batterySource: 0
          });
        }

        if (pvp > 0 && (mode !== "L" || mode !== "E" || mode !== "Y")) {
          return (loadEnergySource = {
            pvSource: pvp,
            gridSource: 0,
            batterySource: acoap - pvp
          });
        }

        if (pvp === 0 && (mode === "L" || mode === "E" || mode === "Y")) {
          return (loadEnergySource = {
            pvSource: 0,
            gridSource: gdv,
            batterySource: 0
          });
        }

        if (pvp === 0 && (mode !== "L" || mode !== "E" || mode !== "Y")) {
          loadEnergySource = {
            pvSource: 0,
            gridSource: 0,
            batterySource: acoap
          };

          return loadEnergySource;
        }
      }

      return loadEnergySource;
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.header-area {
  display: flex;
  flex-flow: column wrap;
}
.content {
  margin: 0 auto;
  width: 100%;
  max-width: 960px;
}

.title {
  margin-bottom: 50px;
}

.animated-area {
  position: relative;
  width: 320px;
  margin: 0 auto;

  @media (min-width: 768px) and (max-width: 950px) {
  }

  @media (min-width: 950px) {
    width: 600px;
  }
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.justify-center {
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/animated-icons.vue